import * as React from 'react'

interface Props {
  width?: string
  height?: string
  className?: string
}

const SvgPhoneScanIcon: React.FC<Props> = ({
  width = '212',
  height = '212',
  className = '',
}) => (
  <svg
    fill="#000000"
    height={height}
    width={width}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-51.2 -51.2 614.40 614.40"
    className={className}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#000"
      strokeWidth="8.192"
    >
      <g>
        <g>
          <path
            d="M373.21,0H138.79c-23.665,0-42.917,19.252-42.917,42.916v426.168c0,23.664,19.252,42.916,42.917,42.916h234.422
            c23.664,0,42.916-19.252,42.916-42.916V42.916C416.128,19.252,396.875,0,373.21,0z M395.729,469.084
            c0,12.417-10.101,22.518-22.519,22.518H138.79c-12.418,0-22.519-10.101-22.519-22.518v-54.996h279.458V469.084z M395.729,393.689
            H116.271V71.394h279.458V393.689z M395.729,50.996H116.271v-8.08c0-12.417,10.101-22.518,22.519-22.518h234.422
            c12.417,0,22.518,10.101,22.518,22.518V50.996z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M228.234,135.649h-49.748c-5.633,0-10.199,4.567-10.199,10.199v49.748c0,5.632,4.566,10.199,10.199,10.199
            c5.633,0,10.199-4.567,10.199-10.199v-39.548h39.548c5.633,0,10.199-4.567,10.199-10.199
            C238.433,140.217,233.867,135.649,228.234,135.649z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M228.234,290.677h-39.548v-39.548c0-5.632-4.566-10.199-10.199-10.199c-5.633,0-10.199,4.567-10.199,10.199v49.748
            c0,5.632,4.566,10.199,10.199,10.199h49.748c5.633,0,10.199-4.567,10.199-10.199C238.433,295.245,233.867,290.677,228.234,290.677
            z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M333.514,135.649h-49.748c-5.633,0-10.199,4.567-10.199,10.199c0,5.632,4.566,10.199,10.199,10.199h39.548v39.548
            c0,5.632,4.566,10.199,10.199,10.199c5.633,0,10.199-4.567,10.199-10.199v-49.748
            C343.713,140.217,339.147,135.649,333.514,135.649z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M333.514,240.93c-5.633,0-10.199,4.567-10.199,10.199v39.548h-39.548c-5.633,0-10.199,4.567-10.199,10.199
            c0,5.632,4.566,10.199,10.199,10.199h49.748c5.633,0,10.199-4.567,10.199-10.199v-49.748
            C343.713,245.497,339.147,240.93,333.514,240.93z"
          />
        </g>
      </g>
    </g>
    <g id="SVGRepo_iconCarrier">
      <g>
        <g>
          <path
            d="M373.21,0H138.79c-23.665,0-42.917,19.252-42.917,42.916v426.168c0,23.664,19.252,42.916,42.917,42.916h234.422
            c23.664,0,42.916-19.252,42.916-42.916V42.916C416.128,19.252,396.875,0,373.21,0z M395.729,469.084
            c0,12.417-10.101,22.518-22.519,22.518H138.79c-12.418,0-22.519-10.101-22.519-22.518v-54.996h279.458V469.084z M395.729,393.689
            H116.271V71.394h279.458V393.689z M395.729,50.996H116.271v-8.08c0-12.417,10.101-22.518,22.519-22.518h234.422
            c12.417,0,22.518,10.101,22.518,22.518V50.996z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M228.234,135.649h-49.748c-5.633,0-10.199,4.567-10.199,10.199v49.748c0,5.632,4.566,10.199,10.199,10.199
            c5.633,0,10.199-4.567,10.199-10.199v-39.548h39.548c5.633,0,10.199-4.567,10.199-10.199
            C238.433,140.217,233.867,135.649,228.234,135.649z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M228.234,290.677h-39.548v-39.548c0-5.632-4.566-10.199-10.199-10.199c-5.633,0-10.199,4.567-10.199,10.199v49.748
            c0,5.632,4.566,10.199,10.199,10.199h49.748c5.633,0,10.199-4.567,10.199-10.199C238.433,295.245,233.867,290.677,228.234,290.677
            z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M333.514,135.649h-49.748c-5.633,0-10.199,4.567-10.199,10.199c0,5.632,4.566,10.199,10.199,10.199h39.548v39.548
            c0,5.632,4.566,10.199,10.199,10.199c5.633,0,10.199-4.567,10.199-10.199v-49.748
            C343.713,140.217,339.147,135.649,333.514,135.649z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M333.514,240.93c-5.633,0-10.199,4.567-10.199,10.199v39.548h-39.548c-5.633,0-10.199,4.567-10.199,10.199
            c0,5.632,4.566,10.199,10.199,10.199h49.748c5.633,0,10.199-4.567,10.199-10.199v-49.748
            C343.713,245.497,339.147,240.93,333.514,240.93z"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default SvgPhoneScanIcon
